import { routeList } from '@/router/helpers/routes'
import { validateRouteMandatoryProps } from '@/router/helpers/validations'
/* Views */
import MyCredits from '@/views/credits/MyCredits'
import CreditSolutions from '@/views/credits/CreditSolutions'
import CreditSolutionsSubscribeProduct from '@/views/credits/SubscribeProduct'
import Amortization from '@/views/credits/Amortization'
import UnderDevelopment from '@/views/UnderDevelopment'

export default [{
	path: routeList.CREDITS_BASE_PATH,
	beforeEnter (to, from, next) {
		next(false)
	}
}, {
	path: routeList.CREDITS_MY_CREDITS_PATH,
	name: routeList.CREDITS_MY_CREDITS_NAME,
	component: MyCredits
}, {
	path: routeList.CREDITS_MY_CREDITS_AMORTIZATION_PATH,
	name: routeList.CREDITS_MY_CREDITS_AMORTIZATION_NAME,
	props: true,
	component: Amortization,
	beforeEnter (to, from, next) {
		validateRouteMandatoryProps(to, from, next, routeList.CREDITS_MY_CREDITS_NAME)
	}
}, {
	path: routeList.CREDITS_CREDIT_SOLUTIONS_PATH,
	name: routeList.CREDITS_CREDIT_SOLUTIONS_NAME,
	props: true,
	component: CreditSolutions
}, {
	path: routeList.CREDIT_CREDIT_SOLUTIONS_SUBSCRIBE_PRODUCT_PATH,
	name: routeList.CREDIT_CREDIT_SOLUTIONS_SUBSCRIBE_PRODUCT_NAME,
	props: true,
	component: CreditSolutionsSubscribeProduct,
	beforeEnter (to, from, next) {
		validateRouteMandatoryProps(to, from, next, routeList.CREDITS_CREDIT_SOLUTIONS_NAME)
	}
}, {
	path: routeList.CREDITS_HISTORY_PATH,
	name: routeList.CREDITS_HISTORY_NAME,
	component: UnderDevelopment
}]
